import { createSlice } from "@reduxjs/toolkit";

// Only the (non-sensitive) user profile is persisted to localStorage so the UI
// can render logged-in state across reloads. The auth token is NOT stored here
// — it lives in an httpOnly cookie the browser sends automatically.
const storedUser = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;

const initialState = {
  user: storedUser,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      // Accepts the login/signup response body ({ user, ... }).
      const user = action.payload?.user ?? action.payload;
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },

    logout: (state) => {
      state.user = null;
      localStorage.removeItem("user");
      // Clean up the legacy combined key if present from older sessions.
      localStorage.removeItem("userInfo");
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
